<script setup lang="ts">
import {ButtonIcon} from '@helcim/blizzard';
import StoreDetails from './StoreDetails.vue';
import StoreInfo from './StoreInfo.vue';
import {useActors} from "../../compositions";
import router from "../../router";
import {LINKS} from "../../scripts/constants";


defineProps<{
    isPortalAllowed: boolean,
}>();

const { customer } = useActors();
const toggleOverride = () => document.body.style.position = 'fixed';
</script>

<template>
    <div id="sticky-top-bar" class="store-top-bar">
        <ButtonIcon
            class="store-top-bar__button"
            ariaLabel="Toggle Menu"
            data-drawer="main-menu"
            icon="far fa-bars fa-lg"
            variant="borderless"/>
        <StoreDetails/>
        <div v-if="!isPortalAllowed" class="store-top-bar__button"/>
        <ButtonIcon
            v-else-if="customer && customer.id > 0"
            class="store-top-bar__button"
            ariaLabel="Toggle Menu"
            icon="fas fa-user fa-lg fa-fw"
            variant="borderless"
            @click="() => {router.push(LINKS.DASHBOARD)}"/>
        <ButtonIcon
            v-else
            class="store-top-bar__button"
            ariaLabel="Toggle Menu"
            data-drawer="account-menu"
            icon="fas fa-user fa-lg fa-fw"
            variant="borderless"
            @click="toggleOverride"/>
    </div>
    <StoreInfo/>
</template>

<style scoped lang="scss">
.store-top-bar {
    flex: auto 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 9;
    padding: 12px 16px 12px 16px;
    background: white;
    &__button {
        height: 32px;
        width: 32px;
    }
}
</style>